import React from 'react';
import PageViewWrapper from 'higherOrder/PageViewWrapper';
import {HelmetWrapper, basicHelmetGenerator} from 'utility/DefaultMeta';

import ContactForm from './components/ContactForm/ContactForm.js'

import {ContactPage} from './Contact.styles.js'

const Contact = (props) => {

  return (
    <ContactPage style={{ padding: `0`, overflow:`hidden`}}>
        <HelmetWrapper metadata={basicHelmetGenerator({
          title:'MRI Technologies - Contact Us',
        })} />
      <ContactForm />
    </ContactPage>
  )
}

export default PageViewWrapper(Contact, {pageName: 'Contact'});;